export enum AccessLevelTypes {
    Manager = 1,
    Assistant = 2,
    CRC = 3,
    Coordinator = 4,
    LeadCoordinator = 5,
    NoRole = 99,
}
